export default __webpack_public_path__ + "assets/icons/mobile-close.26ead9c5.svg";